export default __webpack_public_path__ + "static/media/earth.27c837f9.jpg";